import React, { useState } from "react";
import styled from "styled-components";
import { Colors } from "../../config/Constants";

interface TicketCarouselProps {
  item: {
    category?: string;
    date?: string;
    dependentProduct?: string | null;
    discountAmount?: number;
    discountPercentage?: number;
    isDependent?: boolean;
    isFree?: boolean;
    isFreeCount?: number;
    name?: string;
    qty?: number;
    unitPrice?: number;
    qr?: { qr: string; productId: string }[];
    bookingDate?: string;
    ticketNo?: string;
    visitTime?: string;
    location?: string;
    totalPrice?: number;
  };
  length: number;
  index: number;
  qrCodeData: any;
}

const TicketCarousel: React.FC<TicketCarouselProps> = ({
  item,
  length,
  index,
  qrCodeData,
}) => {
  const [imageLoading, setIsImageLoading] = useState(true);
  const [activeIdx, setActiveIdx] = useState(0);
  return (
    <MainContainer length={length}>
      <Frame>
        <LogoContainer>
          <OutletLogo
            src={require("../../assets/images/lww_logo.png")}
            alt="Outlet Logo"
          />
        </LogoContainer>
        <TicketDetailsView>
          <ItemSubText>
            <DateText>Date</DateText>
            <DateText>Ticket ID</DateText>
          </ItemSubText>
          <ItemSubText>
            <TicketId>{item?.date}</TicketId>
            <TicketId>{qrCodeData?.ticketNo}</TicketId>
          </ItemSubText>
          <ItemSubText>
            <DateText>Category</DateText>
            <DateText>UNIT</DateText>
          </ItemSubText>
          <div style={{ height: "2rem" }}>
            <ItemSubText>
              <ItemName>{item?.name}</ItemName>
              <ItemQuantity>{item?.qty}</ItemQuantity>
            </ItemSubText>
          </div>
          <ItemSubText style={{ paddingTop: "2rem" }}>
            <DateText>Visit Time</DateText>
            <DateText>Location</DateText>
            <DateText>Total Amount</DateText>
          </ItemSubText>
          <ItemSubText style={{ marginBottom: "30px" }}>
            <ItemTime className="textAlignLeft">
              {qrCodeData?.visitingHour}
            </ItemTime>
            <ItemLocation className="textAlignCenter">
              {qrCodeData?.visitingLocation}
            </ItemLocation>
            <ItemText className="textAlignRight">
              {item?.totalPrice !== undefined && `${item?.totalPrice} QAR`}
            </ItemText>
          </ItemSubText>
        </TicketDetailsView>
        <BottomBlueView>
          {item?.qr ? (
            <QrView>
              {/* {item.qr.map((qr) => ( */}
              <div
                style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
              >
                <ArrowButtons
                  disabled={activeIdx === 0}
                  onClick={() => setActiveIdx(activeIdx - 1)}
                >
                  <img
                    style={{ width: "0.5rem" }}
                    src={require("../../assets/images/left-arrow-icon.png")}
                  />
                </ArrowButtons>
                <QrImage
                  // @ts-ignore
                  src={item?.qr?.[activeIdx]?.qr}
                  onLoad={() => setIsImageLoading(false)}
                  alt="QR Code"
                />
                <ArrowButtons
                  disabled={activeIdx + 1 === item?.qr?.length}
                  onClick={() => setActiveIdx(activeIdx + 1)}
                >
                  <img
                    style={{ width: "0.5rem" }}
                    src={require("../../assets/images/right-arrow-icon.png")}
                  />
                </ArrowButtons>
              </div>
              {/* ))} */}
              <NiceDayText>{qrCodeData?.ticketNo}</NiceDayText>
            </QrView>
          ) : (
            <NoQrText>No QR code available</NoQrText>
          )}
        </BottomBlueView>
      </Frame>
    </MainContainer>
  );
};

const ArrowButtons = styled.button`
  background: white;
  height: 24px;
  width: 24px;
  border: none;
  border-radius: 24px;
  display:flex;
  justify-content:center;
  align-items:center;
&:disabled{
opacity:0.5;
}
`;

// Styled Components
const MainContainer = styled.div<{ length: number }>`
  align-self: center;
  width: 100%;
  max-width: 500px;
`;

const Frame = styled.div`
  background-color: ${Colors.athensGrey};
  margin: 10px 0;
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const LogoContainer = styled.div`
  background-color: ${Colors.ticketColorBlue};
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
`;

const OutletLogo = styled.img`
  height: 100px;
  max-width: 100%;
  object-fit: contain;
`;

const TicketDetailsView = styled.div`
  align-self: center;
  margin-top: 10px;
  width: 90%;
`;

const ItemSubText = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
`;

const DateText = styled.p`
  color: ${Colors.black};
  font-size: 10px;
  margin: 0;
`;

const TicketId = styled.p`
  color: ${Colors.black};
  font-size: 0.8rem;
  margin-top: 0.3rem;
`;

const ItemText = styled.p`
  color: ${Colors.black};
  font-size: 0.8rem;
  margin: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-top: 0.3rem;
`;

const ItemName = styled(ItemText)`
  width: 65%;
  white-space: normal;
  overflow-wrap: break-word;
  text-align: left;
`;

const ItemTime = styled(ItemText)`
  width: 30%;
  white-space: normal;
  overflow-wrap: break-word;
  text-align: left;
`;

const ItemLocation = styled(ItemText)`
  width: 40%;
  white-space: normal;
  overflow-wrap: break-word;
  text-align: left;
`;

const ItemPrice = styled(ItemText)`
  width: 50%;
  white-space: normal;
  overflow-wrap: break-word;
  text-align: center;
`;

const ItemQuantity = styled(ItemText)`
  margin-right: 10px;
`;

const BottomBlueView = styled.div`
  width: 100%;
  background-color: ${Colors.ticketColorBlue};
  border-bottom-left-radius: 1rem;
  border-bottom-right-radius: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
`;

const QrView = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-top: 10px;
`;

const QrImage = styled.img`
  height: 130px;
  width: 130px;
`;

const NiceDayText = styled.p`
  color: ${Colors.white};
  font-size: 1rem;
  text-align: center;
  margin-top: 10px;
`;

const NoQrText = styled.p`
  color: ${Colors.black};
  font-size: 1rem;
  text-align: center;
  margin-top: 10px;
`;

export default TicketCarousel;
